import {
  ActionType,
  ComponentType,
  MessageSubType,
  VaFalseCannedResponse,
  vaFalseInitialDialog,
} from '../../../types/enum';

export function createVaFalseInitialMessage(translateService): Message {
  return <Message>{
    time: new Date(),
    isQuickReply: true,
    messageSubType: MessageSubType.ASK_TO_LOGIN,
    messageComponent: {
      component: ComponentType.DialogMessageComponent,
      componentData: {
        cardText: translateService.instant('VA_FALSE_LINKS.CARD_TEXT'),
        cannedResponses: [
          {
            value: translateService.instant('VA_FALSE_LINKS.SIGN_INTO_ACCOUNT'),
            key: VaFalseCannedResponse.SIGN_INTO_ACCOUNT,
            response: vaFalseInitialDialog,
          },
          {
            value: translateService.instant('VA_FALSE_LINKS.UNABLE_TO_SIGN_IN'),
            key: VaFalseCannedResponse.UNABLE_TO_SIGN_IN,
            response: vaFalseInitialDialog,
          },
          {
            value: translateService.instant('VA_FALSE_LINKS.NOT_A_CUSTOMER'),
            key: VaFalseCannedResponse.NOT_A_CUSTOMER,
            response: vaFalseInitialDialog,
          },
        ],
      },
      actions: {
        onCannedResponseClick: ActionType.CannedResponseClick,
      },
    },
  };
}
